import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["preserveAspectRatio", "viewBox"];
import React from 'react';

var File = function File(_ref) {
  var _ref$preserveAspectRa = _ref.preserveAspectRatio,
      preserveAspectRatio = _ref$preserveAspectRa === void 0 ? 'xMidYMid meet' : _ref$preserveAspectRa,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 21 23' : _ref$viewBox,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({}, unhandledProps, {
    preserveAspectRatio: preserveAspectRatio,
    viewBox: viewBox
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4323 2.91628C12.2799 2.76328 12.0492 2.71716 11.8499 2.79984C11.6499 2.88309 11.52 3.07884 11.52 3.29597V5.96334C11.52 6.25978 11.7597 6.49997 12.0543 6.49997H14.7098C14.9259 6.49997 15.1203 6.36947 15.2037 6.16866C15.286 5.96784 15.2401 5.73666 15.0878 5.58366L12.4323 2.91628Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4763 7.625C10.8816 7.625 10.4 7.14125 10.4 6.54388V2.53663C10.4 2.24019 10.1603 2 9.86576 2H3.6604C2.74312 2 2 2.74644 2 3.66781V18.3322C2 19.2536 2.74312 20 3.6604 20H14.3396C15.2569 20 16 19.2536 16 18.3322V8.16163C16 7.86519 15.7603 7.625 15.4658 7.625H11.4763Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "6",
    y: "9",
    width: "6",
    height: "1",
    rx: "0.5",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "6",
    y: "11",
    width: "6",
    height: "1",
    rx: "0.5",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "6",
    y: "13",
    width: "6",
    height: "1",
    rx: "0.5",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "6",
    y: "15",
    width: "6",
    height: "1",
    rx: "0.5",
    fill: "white"
  }));
};

File.displayName = 'File';
export default File;